import axios from '@axios'

const route = 'configuration/company'

export default {
  namespaced: true,
  state: {
    company: {},
    address: [],
    originCustomer: [],

  },
  getters: {
    getCompany: state => state.company,
    getAddress: state => state.address,
    getOriginCustomer: state => state.originCustomer,
  },
  mutations: {

    setCompany(state, company) {
      state.company = company
    },

    setAddress(state, address) {
      address.forEach(element => {
        element.loading = false
      })
      state.address = address
    },
    setOriginCustomer(state, originCustomer) {
      originCustomer.forEach(element => {
        element.loading = false
      })
      state.originCustomer = originCustomer
    },
  },
  actions: {
    /**
     * salva os dados da empresa
     */
    updateOrCreate(context) {
      const { company } = context.state

      return axios.post(route, company)
    },

    /**
     * Carrega os dados da empresa
     */
    loadCompany(context) {
      return axios.get(route)
    },

    /**
     * salva o endereços da empresa
     */
    createAddress(context, address) {
      return axios.post(`${route}/address`, address)
    },

    /**
     * remove o endereços da empresa
     */
    removeAddress(context, addressId) {
      return axios.delete(`${route}/address/${addressId}`)
    },

    /**
     * salva a origem do cliente
     */

    createOriginCustomer(context, origin) {
      return axios.post(`${route}/origin_customer`, origin)
    },

    /**
     * remove a origem do cliente
     */
    removeOriginCustomer(context, originId) {
      return axios.delete(`${route}/origin_customer/${originId}`)
    },

    /**
     * Upload da logomarca da empresa
     */
    uploadLogoCompany(context, logo) {
      const formData = new FormData()
      formData.append('logo', logo)

      return axios.post(`${route}/upload_logo_company`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
  },
}
